export default function initializeGoogleAnalytics() {
    if (process.env.NODE_ENV === 'production') {
        // Add preconnect link for better performance
        const preconnectLink = document.createElement('link');
        preconnectLink.href = 'https://www.googletagmanager.com';
        preconnectLink.rel = 'preconnect';
        preconnectLink.crossOrigin = 'anonymous';
        document.head.appendChild(preconnectLink);

        // Dynamically load Google Analytics script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GA_MEASUREMENT_ID}&`;
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            // Initialize Google Analytics
            // gtag.js only reads the arguments object, not arrays
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                // eslint-disable-next-line prefer-rest-params
                window.dataLayer.push(arguments);
            };
            window.gtag('js', new Date());
            window.gtag('config', process.env.VUE_APP_GA_MEASUREMENT_ID);
        };
    }
}
